import { css } from 'linaria';
import { styled } from 'linaria/react';

export const productCardInfoWrapper = css`
  @media (--from-tablet) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--space-50);
  }
`;

export const productCardInfoWrapperReviewsFormClass = css`
  @media (--to-desktop) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--space-100);

    & > div:first-child {
      gap: var(--space-100);
    }
  }
`;

export const imageWrapper = css`
  position: relative;
  flex-shrink: 0;
`;

export const productName = css`
  border: none !important;
  justify-content: left !important;
  text-decoration: none;
`;

export const productNameTextDefaultClass = css`
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
`;

export const onlineOrderOnly = css`
  display: flex;
  gap: var(--space-50);
  height: var(--space-200);
  margin-top: var(--space-150);
`;

export const secondaryPrice = css`
  position: relative;
  margin-top: var(--space-75);

  @media (--only-mobile) {
    margin-top: var(--space-50);
  }
`;

export const ProductImageReviewsFormContainer = styled.div`
  width: 240px;
  height: 240px;

  @media (--only-desktop) {
    width: 180px;
    height: 180px;
  }

  @media (--to-desktop) {
    width: 80px;
    height: 80px;
  }
`;

export const contentWrapper = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
  margin-bottom: var(--space-200);

  word-break: break-word;

  @media (--to-desktop) {
    margin-bottom: 0px;
  }
`;

export const offerWrapper = css`
  display: flex;
  flex-direction: column;

  @media (--only-mobile) {
    margin-top: auto;
  }
`;

export const availabilityToBuyWrapper = css`
  margin-top: var(--space-300);
`;
